import { ChevronDown } from "lucide-react";
import React from "react";

const ChartSelector = ({ activeChart, onChartTypeChange }) => {
  const chartTypes = [
    { id: "radar", name: "Radar Chart" },
    { id: "bar", name: "Bar Chart" },
    // { id: "pie", name: "Pie Chart" },
    { id: "donut", name: "Donut Chart" },
    { id: "line", name: "Line Chart" },
    { id: "area", name: "Area Chart" },
    // { id: "heatmap", name: "Heatmap" },
  ];

  const [isOpen, setIsOpen] = React.useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (chartId) => {
    onChartTypeChange(chartId);
    setIsOpen(false);
  };

  // Find the active chart name for display
  const activeChartName =
    chartTypes.find((chart) => chart.id === activeChart)?.name ||
    "Select Chart Type";

  return (
    <div className="position-relative d-inline-block text-start">
      <div>
        <button
          type="button"
          className="btn dropdown-toggle w-100 text-start"
          onClick={toggleDropdown}
          aria-haspopup="true"
          aria-expanded={isOpen}
        >
          {activeChartName}
          <ChevronDown className="ms-2" size={16} />
        </button>
      </div>

      {isOpen && (
        <div
          className="dropdown-menu show mt-2 shadow position-absolute w-100"
          style={{ zIndex: 10 }}
        >
          {chartTypes.map((chart) => (
            <button
              key={chart.id}
              onClick={() => handleSelect(chart.id)}
              className={`dropdown-item text-sm ${
                activeChart === chart.id ? "active bg-primary text-white" : ""
              }`}
              role="menuitem"
            >
              {chart.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChartSelector;
